import { CloudflareResource } from "../../types/resources";
import { generateAPI } from "../api.generator";

export const getCloudflareBatchToken = generateAPI<
  {},
  CloudflareResource
>("get", "resources/cloudflare-batch-token");
